import { gql } from '@apollo/client';

export const ADD_UPDATE_CONVENTION_GENERAL_DATA = gql`
  mutation addOrUpdateInsuranceConvention($input: ConventionGeneralDataInput!) {
    addOrUpdateInsuranceConvention(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const UPDATE_INSURANCE_CONVENTION_CONDITIONS = gql`
  mutation updateInsuranceConventionConditions($input: InsuranceConventionConditionsInput!) {
    updateInsuranceConventionConditions(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const ADD_UPDATE_INSURANCE_CONVENTION_RISK = gql`
  mutation addOrUpdateInsuranceConventionRisk($input: InsuranceConventionRiskInput!) {
    addOrUpdateInsuranceConventionRisk(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const DELETE_INSURANCE_CONVENTION_RISK = gql`
  mutation deleteInsuranceConventionRisk($productId: Int!, $insuranceTypeId: Int!, $riskTypeId: Int!) {
    deleteInsuranceConventionRisk(productId: $productId, insuranceTypeId: $insuranceTypeId, riskTypeId: $riskTypeId) {
      commandId
      correlationId
    }
  }
`;

export const ADD_UPDATE_CONVENTION_COMMISSIONS = gql`
  mutation addOrUpdateConventionCommission($input: AddOrUpdateConventionCommissionInput!) {
    addOrUpdateConventionCommission(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const DELETE_INSURANCE_CONVENTION_COMMISSION = gql`
  mutation deleteInsuranceConventionCommission($productId: Int!, $insuranceTypeId: Int!) {
    deleteInsuranceConventionCommission(productId: $productId, insuranceTypeId: $insuranceTypeId) {
      commandId
      correlationId
    }
  }
`;

export const ADD_UPDATE_INSURANCE_USAGE_GRID = gql`
  mutation addOrUpdateInsuranceUsageGrid($input: InsuranceUsageGridInput!) {
    addOrUpdateInsuranceUsageGrid(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const DELETE_INSURANCE_USAGE_GRID = gql`
  mutation deleteInsuranceUsageGrid($id: Int!) {
    deleteInsuranceUsageGrid(id: $id) {
      commandId
      correlationId
    }
  }
`;

export const ADD_UPDATE_INSURANCE_CONVENTION_INSURER = gql`
  mutation addOrUpdateInsuranceConventionInsurer($input: InsuranceConventionInsurerDataInput!) {
    addOrUpdateInsuranceConventionInsurer(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const DELETE_CONVENTION_INSURER = gql`
  mutation deleteInsuranceConventionInsurer($productId: Int!, $insurerId: Int!) {
    deleteInsuranceConventionInsurer(productId: $productId, insurerId: $insurerId) {
      commandId
      correlationId
    }
  }
`;

export const ADD_UPDATE_INSURANCE_CONVENTION_ITEM_TYPE = gql`
  mutation addOrUpdateConventionItemType($input: InsuranceConventionItemTypeInput!) {
    addOrUpdateConventionItemType(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const DELETE_INSURANCE_CONVENTION_ITEM_TYPE = gql`
  mutation deleteInsuranceConventionItemType($productId: Int!, $itemTypeId: Int!) {
    deleteInsuranceConventionItemType(productId: $productId, itemTypeId: $itemTypeId) {
      commandId
      correlationId
    }
  }
`;

export const UPDATE_CALCULATION_INFO = gql`
  mutation updateCalculationInfo($input: PercentCalculationInput!) {
    updateCalculationInfo(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const ADD_UPDATE_INSURANCE_CONVENTION_DEDUCTIBLE_COST = gql`
  mutation addOrUpdateInsuranceConventionDeductibleCost($input: InsuranceConventionDeductibleCostInput!) {
    addOrUpdateInsuranceConventionDeductibleCost(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const DELETE_INSURANCE_CONVENTION_DEDUCTIBLE_COST = gql`
  mutation deleteInsuranceConventionDeductibleCost($deductibleCostId: Int!) {
    deleteInsuranceConventionDeductibleCost(deductibleCostId: $deductibleCostId) {
      commandId
      correlationId
    }
  }
`;

export const ADD_UPDATE_INSURANCE_CONVENTION_ADDITIONAL_DATA = gql`
  mutation addOrUpdateInsuranceConventionAdditionalData($input: InsuranceConventionAdditionalDataInput!) {
    addOrUpdateInsuranceConventionAdditionalData(input: $input) {
      commandId
      correlationId
    }
  }
`;

export const DELETE_INSURANCE_CONVENTION_ADDITIONAL_DATA = gql`
  mutation deleteInsuranceConventionAdditionalData($insuranceConventionAdditionalDataId: Int!) {
    deleteInsuranceConventionAdditionalData(insuranceConventionAdditionalDataId: $insuranceConventionAdditionalDataId) {
      commandId
      correlationId
    }
  }
`;
